module.exports = __webpack_public_path__ + "img/logo.a7f72c7f.png";